<div class="app-body">
    <main class="main d-flex align-items-center">
        <div class="container">
            <div class="row">
                <div class="col-md-6 mx-auto">
                    <div class="card-group">
                        <div class="card p-4">
                            <div class="card-body">
                                <h1>Demo-Zugang</h1>
                                <p class="text-muted">Testen Sie NoteRadar ohne Einschränkungen für 3 Tage! Sofort nach
                                    der Registrierung nutzbar - erleben Sie alle Funktionen und entdecken Sie, wie
                                    NoteRadar Ihre Arbeit effizienter gestalten kann.</p>
                                <form #demoForm="ngForm" (submit)="setupDemo()" class="pt-3">
                                    <div class="form-group">
                                        <input type="email" class="form-control" name="companyName"
                                               [(ngModel)]="demoData.companyName"
                                               [disabled]="registrationInProgress"
                                               placeholder="Firmenname"
                                               autocomplete="off" required
                                               appAutofocus>
                                    </div>
                                    <div class="form-group">
                                        <input type="email" class="form-control" name="email"
                                               [(ngModel)]="demoData.email"
                                               [disabled]="registrationInProgress"
                                               placeholder="E-Mail"
                                               email
                                               autocomplete="off" required>
                                    </div>
                                    <div class="form-group">
                                        <input type="password" class="form-control" name="password"
                                               [(ngModel)]="demoData.password"
                                               [disabled]="registrationInProgress"
                                               placeholder="Passwort (mind. 8 Zeichen)"
                                               autocomplete="off" required
                                               minlength="8"
                                               #password="ngModel">
                                        <div *ngIf="password.invalid && (password.dirty || password.touched)"
                                             class="text-danger small mt-1">
                                            <div *ngIf="password.errors?.['minlength']">
                                                Passwort muss mindestens 8 Zeichen lang sein.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <input type="password" class="form-control" name="confirmPassword"
                                               [(ngModel)]="demoData.confirmPassword"
                                               [disabled]="registrationInProgress"
                                               placeholder="Passwort bestätigen"
                                               autocomplete="off" required
                                               #confirmPassword="ngModel">
                                        <div *ngIf="demoData.confirmPassword && demoData.password" class="mt-1 small"
                                             [ngClass]="{'text-success': passwordsMatch(), 'text-danger': !passwordsMatch()}">
                                            <span *ngIf="passwordsMatch()">Passwörter stimmen überein.</span>
                                            <span *ngIf="!passwordsMatch()">Passwörter stimmen nicht überein.</span>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div sc-checkbox-re-captcha #recaptcha="ngModel" [(ngModel)]="recaptchaResponse" name="recaptcha" required></div>
                                    </div>
                                    <button [disabled]="registrationInProgress || demoForm.invalid" type="submit"
                                            class="btn btn-primary btn-block">Demozugang anlegen
                                    </button>

                                    <div *ngIf="registrationInProgress" class="text-center mt-3">
                                        <div class="spinner-border text-primary" role="status">
                                            <span class="sr-only"></span>
                                        </div>
                                        <div class="mt-2">Der Zugang wird angelegt. Dies kann einige Sekunden dauern...</div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>
